// containers
import { Navigation } from '@/containers-m/Navigation';
import { Footer } from '@/containers-m/Footer';
import { WeInNumbers } from '@/containers-latam/WeInNumbers';

//context containers
import {
  Hero,
  VideoHero,
  OfferList,
  MissionBanner,
  OurStory,
  BackgroundImageSection,
  Awards,
} from './containers';

//styles
import { PageWrapper } from './About.styles';

function About({
  hero_content,
  offerList_content,
  missionBanner_content,
  ourStory_content,
  weInNumbers_content,
  backgroundImageSection_content,
  awards_content,
  videoUrl,
  awards,
  nav,
  footer,
}) {
  return (
    <PageWrapper>
      <Navigation nav={nav} />
      <>
        <Hero content={hero_content} />
        <VideoHero url={videoUrl} />
        <OfferList content={offerList_content} />
        <MissionBanner content={missionBanner_content} />
        <OurStory content={ourStory_content} />
        <WeInNumbers content={weInNumbers_content} />
        <BackgroundImageSection content={backgroundImageSection_content} />
        <Awards content={awards_content} awards={awards} />
      </>
      <Footer config={footer} />
    </PageWrapper>
  );
}

export default About;
export { About };
